import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

// Prev/next arrows and the current range label. Pure presentational — state
// lives in useCalendarNav.
//
// The "Today" jump moved OUT of here and into the Today/Week/Day control
// (GRAVY-10329), which is where the design puts it. Keeping both rendered two
// buttons named "Today" side by side.
//
// `unit` drives the arrows' accessible names, because the same control steps a
// week in the week view and a DAY in the day view. Labelling both "Previous
// week" would tell a screen-reader user the wrong thing about half the time.

type Props = {
  rangeLabel: string;
  unit?: 'day' | 'week';
  onPrev: () => void;
  onNext: () => void;
};

const WeekNav = ({ rangeLabel, unit = 'week', onPrev, onNext }: Props) => (
  <div className="dashv2-weeknav">
    <div className="dashv2-nav-group">
      <button
        type="button"
        className="dashv2-iconbtn"
        aria-label={`Previous ${unit}`}
        onClick={onPrev}
      >
        <ChevronLeftIcon />
      </button>
      <span className="dashv2-range">{rangeLabel}</span>
      <button
        type="button"
        className="dashv2-iconbtn"
        aria-label={`Next ${unit}`}
        onClick={onNext}
      >
        <ChevronRightIcon />
      </button>
    </div>
  </div>
);

export default WeekNav;
